import SEOHead from "@/components/feature/SEOHead";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import FloatingButton from "@/components/feature/FloatingButton";

export default function Merci() {
  return (
    <div className="font-sans">
      <SEOHead
        title="Merci | Dépan'Volets Strasbourg"
        description="Votre demande a bien été envoyée. Nous vous recontactons sous 24h. Dépan'Volets, 82 Rue de Heidenberg, 67200 Strasbourg. 03 74 47 32 40."
        path="/merci"
        robots="noindex, nofollow"
      />
      <Navbar />
      <main className="pt-16 md:pt-20 min-h-[60vh] flex items-center justify-center bg-brand-light">
        <div className="max-w-xl mx-auto px-4 md:px-8 py-20 md:py-28 text-center">
          <div className="w-20 h-20 mx-auto mb-6 flex items-center justify-center rounded-full bg-brand-cyan/10">
            <i className="ri-check-line text-brand-cyan text-4xl"></i>
          </div>
          <h1 className="text-2xl md:text-4xl font-bold text-brand-blue mb-4">
            Merci, votre demande est bien envoyée
          </h1>
          <p className="text-brand-text text-base md:text-lg mb-10 max-w-md mx-auto">
            Nous vous recontactons sous 24h.
          </p>
          <a
            href="/"
            className="inline-flex items-center justify-center gap-2 bg-brand-cyan text-white px-8 py-4 rounded-full font-semibold text-base hover:scale-[1.02] active:scale-[0.98] hover:shadow-[0_4px_20px_rgba(0,179,164,0.35)] transition-all duration-300 whitespace-nowrap"
          >
            <i className="ri-home-line text-lg"></i>
            Retour à l'accueil
          </a>
        </div>
      </main>
      <Footer />
      <FloatingButton />
    </div>
  );
}